module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.file) ? _c('div', {
    staticClass: "file-container"
  }, [_vm._m(0), _vm._v("\n    " + _vm._s(_vm.file.name) + "\n    "), _c('span', {
    staticClass: "delete-file-message",
    on: {
      "click": function($event) {
        return _vm.cancelFile()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/close.svg"),
      "alt": "close icon",
      "height": "10",
      "title": "Remove the file"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "sc-user-input",
    class: {
      active: _vm.inputActive
    }
  }, [_c('div', {
    ref: "userInput",
    staticClass: "sc-user-input--text",
    attrs: {
      "role": "button",
      "tabIndex": "0",
      "contentEditable": "true",
      "placeholder": _vm.placeholder
    },
    on: {
      "focus": function($event) {
        return _vm.setInputActive(true)
      },
      "blur": function($event) {
        return _vm.setInputActive(false)
      },
      "keydown": _vm.handleKey
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-user-input--buttons"
  }, [_c('div', {
    staticClass: "sc-user-input--button"
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-user-input--button"
  }, [_c('SendIcon', {
    attrs: {
      "onClick": _vm._submitText
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-file-message"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/file.svg"),
      "alt": "genericFileIcon",
      "height": "15"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74333e58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/UserInput.vue
// module id = 1268
// module chunks = 1